export const mysteryDetailLightTheme = {
  '--mystery-detail-bgc-1': '#f8f8f8',
  '--mystery-detail-bgc-2': 'rgba(0, 0, 0, 0.34)',
  '--mystery-detail-bgc-3': '#f8f8f8',
  '--mystery-detail-bgc-4': '#65d5ff',
  '--mystery-detail-bgc-5': '#eee',
  '--mystery-detail-bgc-6': '#fff',
  '--mystery-detail-bgc-7': 'linear-gradient(135deg, #36ddfe, #0b8fe7)',
  '--mystery-detail-font-c-1': '#333',
  '--mystery-detail-font-c-2': '#fff',
  '--mystery-detail-font-c-3': '#666',
  '--mystery-detail-font-c-4': '#65d5ff',
  '--mystery-detail-font-c-5': '#666',
  '--mystery-detail-font-c-6': '#65d5ff',
  '--mystery-detail-font-c-7': '#666',
  '--mystery-detail-border-c-1': '#eee',
  '--mystery-detail-border-c-2': 'linear-gradient(135deg, #31d3fa, #15a1eb) 1 1',
  '--mystery-detail-border-c-3': '#eee',
}
export const mysteryDetailDarkTheme = {
  '--mystery-detail-bgc-1': '#222e3d',
  '--mystery-detail-bgc-2': 'rgba(255, 255, 255, 0.34)',
  '--mystery-detail-bgc-3': '#23262f',
  '--mystery-detail-bgc-4': '#65d5ff',
  '--mystery-detail-bgc-5': '#3b3e49',
  '--mystery-detail-bgc-6': '#141417',
  '--mystery-detail-bgc-7': 'linear-gradient(135deg, #36ddfe, #0b8fe7)',
  '--mystery-detail-font-c-1': '#fff',
  '--mystery-detail-font-c-2': '#fff',
  '--mystery-detail-font-c-3': '#9fa7b3',
  '--mystery-detail-font-c-4': '#65d5ff',
  '--mystery-detail-font-c-5': '#fff',
  '--mystery-detail-font-c-6': '#fff',
  '--mystery-detail-font-c-7': '#b6bfc3',
  '--mystery-detail-border-c-1': '#23262f',
  '--mystery-detail-border-c-2': 'linear-gradient(135deg, #31d3fa, #15a1eb) 1 1',
  '--mystery-detail-border-c-3': '#353945',
}
